module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-yellow.254ac6e3.svg";